import { REQUEST } from '../actions/action_types';
import { UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION } from '../actionTypes/collection';

const initState = {
  updateFolderPublicStatusState: REQUEST.INIT,
};

export default (state = initState, action) => {
  switch (action.type) {
    case UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.INIT:
      return {
        ...state,
        updateFolderPublicStatusState: REQUEST.INIT,
      };
    case UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.LOADING:
      return {
        ...state,
        updateFolderPublicStatusState: REQUEST.LOADING,
      };
    case UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.SUCCESS:
      return {
        ...state,
        updateFolderPublicStatusState: REQUEST.SUCCESS,
      };
    case UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.FAIL:
      return {
        ...state,
        updateFolderPublicStatusState: REQUEST.FAIL,
      };
    default:
      return state;
  }
};
